import React from "react";
import ProfileSurveyContainer from "../containers/ProfileSurveyContainer";

export const ProfileSurveyPage: React.FunctionComponent = () => <ProfileSurveyContainer />;